import { render, staticRenderFns } from "./ShowWrapper.vue?vue&type=template&id=ee5b4332&"
import script from "./ShowWrapper.vue?vue&type=script&lang=ts&"
export * from "./ShowWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports